import { videoRouter, embedVideoRouter, embedWxworkVideoRouter } from './video';
import NotFound from '@/views/NotFound.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const baseRoutes = [
  {
    path: '/embed/wxwork/noauth',
    component: DefaultLayout,
    props: { hasHeadBar: true },
    name: 'noauth',
    children: [
      {
        path: ':id?',
        name: 'noauth',
        component: () => import('@/views/NoAuth.vue'),
        meta: {
          auth: true
        }
      }
    ]
  },
  {
    path: '/noauth',
    component: DefaultLayout,
    name: 'noauth',
    children: [
      {
        path: ':id?',
        name: 'noauth',
        component: () => import('@/views/NoAuth.vue'),
        meta: {
          // auth: true
        }
      }
    ]
  }
];

export let combinedRoutes = baseRoutes.concat(
  videoRouter,
  embedVideoRouter,
  embedWxworkVideoRouter,
  [
    {
      // 其它没有匹配到的路由都会跳至此模块(404）
      // 该路由为必须路由，不需要权限，必须放在最后combinedRoutes
      path: '*',
      name: 'notfound',
      component: NotFound,
      meta: { keepAlive: false }
    }
  ]
);
